export default {"src":"/uk/_next/static/media/twoFAIcon.dec29e6f.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};